import(/* webpackMode: "eager", webpackExports: ["StatisticsDisplay"] */ "/app/src/components/Statistics/StatisticsDisplay.tsx");
